import { useContext } from "react";
import ConfirmContext from 'store/ConfirmContext';
import { SHOW_CONFIRM, HIDE_CONFIRM} from  'store/confirmReducer';


let resolveCallback;
function useConfirm() {
    const [confirmState, dispatch] = useContext(ConfirmContext);

    const onConfirm = () => {
        closeConfirm();
        resolveCallback(true);
    };

    const onCancel = () => {
        closeConfirm();
        resolveCallback(false);
    };

    const confirm = ({title, text, rejectLabel='Cancel', confirmLabel='OK', width='sm', showReject=true}) => {
        dispatch({
            type: SHOW_CONFIRM,
            payload: {
                title,
                text,
                rejectLabel,
                confirmLabel,
                width,
                showReject
            }
        });
        return new Promise((res, rej) => {
            resolveCallback = res;
        });
    };

    const closeConfirm = () => {
        dispatch({
            type: HIDE_CONFIRM
        });
    };

    return { confirm, onConfirm, onCancel, confirmState}

}

export default useConfirm;